import { useTranslation } from 'react-i18next';
import { useOrgStore } from '@Models/useOrgModel';
import { OverflowTooltip, Text, TextLabel } from '@tonic-one/react';
import React from 'react';

export default function RenderLabel(
  allChecked: boolean,
  checkedItems: boolean[]
) {
  const { t } = useTranslation();
  const orgModel = useOrgStore();
  const orgs = orgModel.orgs?.filter((x) => x.key !== 'all');
  const isNoneSelected = checkedItems.every((item) => item === false);

  if (isNoneSelected) {
    return <TextLabel mr="2x">{t('common.label.selectOrg')}</TextLabel>;
  }

  const label = allChecked
    ? t('common.label.allOrganizations')
    : orgs
      ? orgs
          .filter((_, index) => checkedItems[index])
          .map((org) => org.value)
          .join(',')
      : '';
  return (
    <>
      <OverflowTooltip PopperProps={{ usePortal: true }} label={label}>
        {label}
      </OverflowTooltip>
      <Text ml="1x">{`(${
        orgs
          ? orgs
              .filter((_, index) => checkedItems[index])
              .map((org) => org.value).length
          : 0
      })`}</Text>
    </>
  );
}
